import { useQueryClient } from "@tanstack/react-query";
import { Id } from "PFTypes";

import { adminAllocationWindowsKeys } from "./query_keys";

export const useAdminTargetAllocationInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidateSingleAllocationWindow: (allocationWindowId: Id) =>
      queryClient.invalidateQueries({
        queryKey: adminAllocationWindowsKeys.single(allocationWindowId)
      }),
    invalidateAllAllocationWindows: () =>
      queryClient.invalidateQueries({ queryKey: adminAllocationWindowsKeys.all() }),
    invalidateAllRoles: () =>
      queryClient.invalidateQueries({ queryKey: adminAllocationWindowsKeys.allRoles() }),
    invalidateAllFallbackRoles: () =>
      queryClient.invalidateQueries({ queryKey: adminAllocationWindowsKeys.allFallbackRoles(), exact: false })
  };
};
